export default {
  'dbi_label_trend%': '趋势(%)',
  dbi_top_recent: '近期搜索',
  dbi_top_gametitle: '游戏',
  dbi_top_gametitle_b: '游戏 B',
  dbi_top_plan: '发行类型',
  dbi_top_dataai_genre: 'data.ai品类',
  dbi_top_sensortower_genre: 'Sensor Tower品类',
  dbi_top_iegg_genre: 'IEGG品类',
  dbi_top_genre: '品类',
  dbi_top_revenue_per_download: '平均每下载付费',
  dbi_top_editions: '版本',

  dbi_unified_game_details: '统一游戏详情',
  dbi_pc_console_content: '更多游戏指标可在端游 & 主机游戏页面查看',
  dbi_pc_console_metrics_table_intro: '系统根据各游戏在 MScience、Gamalytic、VGInsight 等第三方数据源的可用性进行差异化配置，对原始数据执行跨源融合、缺失值补全与跨时间粒度对齐等预处理。在此基础上，引入由媒体报道、社交平台、公司财报等公开渠道采集的游戏关键节点数据作为真实参照点，对累计趋势曲线进行分段校准，并还原为日、周、月销量增量；最终结合历史价格趋势与各地区价格比例，推算出对应粒度的流水数据。',
  dbi_settings_saved: '取消',
  dbi_confirm_note: '通知',
  dbi_go_pc_console: '访问',
  dbi_not_again: '不再提示',
  dbi_edition_game_details: '分版本游戏详情',
  dbi_leave_your_feedback: '真实数据分享',
  dbi_performance_summary: '表现总结',
  dbi_combine_engagement: '活跃度',
  dbi_combine_engagement_tips: '该游戏的活跃指标KPI数据总值',
  dbi_combine_engagement_tips1: '基于从游戏平台收集的公开用户资料。',
  dbi_combine_engagement_tips2: '提供PC/Console游戏的活跃数据，分全球48个国家数据，有日/月粒度数据。',
  dbi_combine_engagement_tips3: '日数据延时1周，月数据延时一个月。',
  dbi_combine_usrevenue_units: '美国地区收入&销量',
  dbi_combine_us_mscience_zero_tip: `数据来源于 'icon' MScience。`,
  dbi_combine_us_mscience_one_tip: 'MScience通过电子交易记录收集数据。',
  dbi_combine_us_mscience_two_tip: '提供PC/Console游戏的Digital Revenue，仅限美、英、法、德、西，有日/月粒度数据。',
  dbi_combine_us_mscience_three_tip: '美国数据延时6天，欧洲延时7-14天。',
  dbi_combine_us_revenue_units_tip:
    '由于美国市场的抽样数据较多，美区数据提供更为准确和可靠的洞察。因此，我们默认呈现仅美国的数据。',
  dbi_combine_usrevenue_lifetime: '总数',
  dbi_combine_usrevenue_d1after_release: '上线首日',
  dbi_combine_usrevenue_w1after_release: '上线首周',
  dbi_combine_usrevenue_m1after_release: '上线首月',
  dbi_combine_usrevenue_y1after_release: '上线首年',
  dbi_combine_usrevenue_y1after_ea: 'EA首年',
  dbi_combine_usrevenue_last_month: '上个月',
  dbi_combine_steam_Data: 'Steam 数据指标',
  dbi_combine_steam_Data_tips: '当前游戏来自steam平台的kpi数据总值',
  dbi_combine_steam_Data_tips1: 'VG Insights集成来自Steam API、IGDB API以及部分来自SteamSpy的数据。',
  dbi_combine_steam_Data_tips2: '提供仅PC Steam游戏的数据，仅全球不可分国家，有日/周/月粒度数据。',
  dbi_combine_steam_Data_tips3: 'Steam平台数据来自于Steam官网。',
  dbi_combine_steam_Data_tips4: 'VG Insights数据和Steam平台数据延时0-2天。',
  dbi_combine_steam_Data_tips_and: '{vginsights}和{steam}平台数据',
  dbi_combine_steam_Data_gamalytic_tips1: 'Gamalytic集成来自Steam API、IGDB API以及部分来自SteamSpy的数据。',
  dbi_combine_steam_Data_gamalytic_tips2: '提供仅PC Steam游戏的数据，仅全球不可分国家，有日/周/月粒度数据。',
  dbi_combine_steam_Data_gamalytic_tips4: 'Gamalytic数据和Steam平台数据延时0-2天。',
  dbi_combine_databrain_data_tips_title: 'DataBrain校准数据',
  dbi_combine_databrain_data_tips_desc: '提供游戏总收入和游戏本体销量，仅限全球数据，仅限PC&Console合并数据。',
  dbi_combine_databrain_data_tips_update: '更新机制: 延时7天。',
  dbi_combine_streaming: '直播',

  // DataBrain KPI Trends metrics
  dbi_metric_total_revenue: '总收入($)',
  dbi_metric_lifetime_total_revenue: '历史总收入($)',
  dbi_metric_base_game_sales_units: '游戏本体销量',
  dbi_metric_lifetime_base_game_sales_units: '游戏本体历史总销量',
  dbi_true_data_points: '真数点',
  dbi_alinea_true_data_suffix: '真数',
  dbi_metric_mscience_lifetime_digital_revenue: '历史总收入($)',
  dbi_metric_mscience_lifetime_digital_units: '历史线上总销量',
  dbi_combine_streaming_tips: `当前游戏的直播指标kpi总值，数据来源于Stream Hatchet`,
  dbi_combine_stream_tips1: '与Twitch平台有API合作，其他平台合作形式未透露。',
  dbi_combine_stream_tips2:
    '提供Mobile/PC/Console游戏的Twitch/Youtube等直播数据，包含电竞、主播粒度数据。有日粒度数据。',
  dbi_combine_stream_tips3: '日数据延时2天。',
  dbi_editions_list: '版本列表',
  dbi_about_the_game: '游戏简介',
  dbi_screenshots: '截屏',
  dbi_timeline: '版更动态',
  dbi_downloadable_content: '可供下载的内容',
  dbi_similar_games: '相似游戏',
  dbi_related_content: '相关内容',
  dbi_competitors: '竞品',
  dbi_steam_news_announcements: 'Steam 新闻与公告',
  dbi_revenue_dollar: '收入(美元)',
  dbi_select_any_genre: '选择任何品类',
  dbi_select_any_game: '选择任何游戏',
  dbi_shortcut: '快捷键',
  dbi_genre_and: '与',
  dbi_genre_or: '或',
  dbi_choose_andor_for: '为副品类选择与/或',
  dbi_no_results_found: '未找到结果',
  dbi_no_search_results_found: '未快捷搜索到结果，请回车搜索更多游戏',
  dbi_choose_andor_for_tips:
    '单个游戏的品类最多是一个主品类，两个副品类，选择and是至多选择两个副品类，且该游戏品类需要同时满足所选品类，选择or时该游戏至少满足一个所选品类即可。',

  dbi_top_charts_table_selection_limit_title: '抱歉',
  dbi_top_charts_table_selection_limit_tips: '为了获得最佳可视化体验，请最多选择 {num} 个条目。',

  dbi_top_pheat_value: `潜力值`,
  dbi_top_pheat_chart: `潜力值图表`,
  dbi_top_pheat: `潜力值`,
  dbi_top_following_group: '分组',

  dbi_metric_not_suitable: '当前指标不适合用折线图或饼图显示，请查看下表中的数据或跳转至游戏详情页了解更多详情。',

  dbi_top_sales_platform: '销售平台',
  dbi_top_sales_of_selected_time: '选中时间段内的销售额',
  dbi_top_sales_of_selected_time$: '选中时间段内的销售额（美元）',
  dbi_top_price: '价格',
  dbi_top_price$: '价格（美元）',
  dbi_top_revenue_of_selected_time: '选中时间段内的收入',
  dbi_top_revenue_of_selected_time$: '选中时间段内的收入（美元）',
  dbi_top_cumulative_sales: '累计销量',
  dbi_top_cumulative_sales_of_the_latest_week: '最近一周的累计销量',
  dbi_top_cumulative_revenue: '累计收入',
  dbi_top_cumulative_revenue_of_the_latest_week: '最近一周的累计收入',
  dbi_top_cumulative_revenue_of_the_latest_week$: '最近一周的累计收入（美元）',
  // dbi_top_console_japan_sales_price_columns_tips: 'DataBrain 使用固定汇率将 Famiton 列表中的日元转换为美元。',
  dbi_top_console_japan_sales_price_columns_tips: 'DataBrain 采用固定汇率换算法将 Famitsu 榜单上的日元换算成美元。',
  dbi_top_demographics_breakdown: '用户画像细分',
  dbi_top_gender_breakdown: '性别细分',
  dbi_top_age_breakdown: '年龄细分',
  dbi_top_gender: '性别',
  dbi_top_male: '男性',
  dbi_top_female: '女性',
  dbi_top_country: '国家',
  dbi_top_asof: '截止',

  dbi_detail_data_error: '数据相关错误',
  dbi_detail_feedback_record: '反馈记录',
  dbi_detail_feedback_record_small: '条反馈记录',
  dbi_detail_feedback_anonymous: '匿名',
  dbi_feedback_please_select_metric: '请选择指标',
  dbi_feedback_please_input_the_metric: '请输入指标',
  dbi_feedback_delete_failed: '删除失败',
  dbi_feedback_customize: '自定义',
  dbi_feedback_e_g_3m: '例如：如30万套、430万美元等',
  dbi_feedback_upload_image: '上传图片',
  dbi_feedback_link: '链接',
  dbi_feedback_link_placeholder: 'https://',
  dbi_EK_Tip: '匿名发布',
  dbi_EK_user: '匿名用户',
  dbi_feedback_link_placeholder_EK: '具体来源，如米哈游内部员工等',
  dbi_feedback_source: '数据来源',
  dbi_true_data_game_name: '游戏名称',
  dbi_feedback_contributor: '贡献者',
  dbi_feedback_contributor_time: '贡献时间',
  dbi_feedback_edit_public_true_data: '编辑反馈数据',
  dbi_feedback_add_public_true_data: '新增真实数据反馈',
  dbi_top_public_true_data_collection: '真实数据反馈收集',
  dbi_true_data_source_tips:
    '两类真数口径：\nDatabrain 真数：由Data Science团队手动采集并确认过的公开真数节点。\nAlinea Analytics 真数：由数据源采集来自游戏官方平台和发行商社媒发布等公开信息源的公开真数节点。',
  dbi_true_data_load_failed: '真实数据加载失败，请重试。',
  dbi_true_data_download: '下载',
  dbi_feedback_public_data: '公开数据',
  dbi_feedback_expert_knowledge: '专家经验',
  dbi_feedback_financial_reports: '财报',
  dbi_feedback_public_others: '其他来源',
  dbi_feedback_you_sure_delete_true_data: '您确定要删除这条真实数据反馈吗?',
  dbi_feedback_note: '备注',
  dbi_action: '操作',
  dbi_feedback_note_plc: '请输入备注',
  dbi_feedback_enter_correct_web_site: '请输入正确的网址',
  dbi_feedback_data_must_be_in: '数据不可为空',
  dbi_feedback_Metric_must_be_in: '指标不可为空',
  dbi_feedback_date_must_be_in: '日期不可为空',
  dbi_feedback_game_must_be_in: '游戏不可为空',
  dbi_game_placeholder: '请选择游戏',
  dbi_identification_auto: '智能识别',
  dbi_identification_label: '智能识别',
  dbi_identification_placeholder: '例如：2024年3月，博德之门3销量超过1500万套',
  dbi_feedback_source_must_be_in: '数据源不可为空',
  dbi_feedback_time: '具体时间',
  dbi_feedback_once: '模糊时间', // 曾经某次
  dbi_plc_once: '请输入模糊时间',
  dbi_detail_post_anonymously: '匿名发布',
  dbi_detail_no_feedback_the_moment: '当前没有反馈',
  // dbi_detail_post_anonymously_on_the_switch: 'You can post under your real name or anonymously by turning on the switch.',
  dbi_detail_basic_information_error: '基本信息错误',
  dbi_detail_true_data: '真实数据',
  dbi_detail_missing_data: '数据缺失',
  dbi_detail_feature_suggestion: '功能建议',
  dbi_top_free: '免费榜',
  dbi_top_new_free: '新免费榜',
  dbi_top_paid: '付费榜',
  dbi_top_new_paid: '新付费榜',
  dbi_top_grossing: '畅销榜',
  dbi_top_ratings: '评分',
  dbi_top_xbox_upcoming: 'Xbox即将发布榜单',
  dbi_top_xbox_most_played: 'Xbox登录最多榜单',

  dbi_detail_jump_to_options: '跳转至舆情界面',
  dbi_detail_feeds: '评论',
  dbi_detail_strengths_weakness: '优势与劣势',
  dbi_detail_mentions_sentiment: '声量与情感分',
  dbi_detail_mentions: '声量',
  dbi_detail_sentiment: '情感分',
  dbi_detail_no_data_under: '当前过滤选项下无数据。',
  dbi_mobile_stats_active_users_table_nodata:
    '活跃数据暂不可用。游戏需上线至少一周且全球累计下载量达到 50 万次后，Sensor Tower 才会提供活跃数据。',
  dbi_detail_translate: '翻译',
  dbi_detail_volume_of_mentions: '话题声量',
  dbi_detail_games_store: '游戏商店',
  dbi_detail_news_media: '新闻媒体',
  dbi_top_charts: '排行榜',

  dbi_create_new_group: '创建一个新的分组',
  dbi_delete_group: '删除分组',
  dbi_duplicate: '复制',
  dbi_no_following_games_yet: '没有关注的游戏，',
  dbi_top_please: '请',
  dbi_follow_new_games: '关注新游戏',
  dbi_follow_new_companies: '关注新公司',
  dbi_there_no_game_group: '当前分组内没有游戏。',
  dbi_there_no_companies_group: '当前分组内没有公司。',
  dbi_add_to_group: '添加至组别',
  dbi_rename_group: '分组重命名',
  dbi_group_name: '分组名称',
  dbi_new_group: '新分组',
  dbi_not_include_these_characters: `请输入不包含这些字符的名称：`,
  dbi_group_name_exists: '该组名称已存在。',
  dbi_group_created_success: '分组创建成功！',
  dbi_group_created_failed_again: '分组创建失败，请重试！',
  dbi_rename_failed_again: '重命名失败，请重试！',
  dbi_maximum_characters: '最多30个字符',
  dbi_name_the_group: '请给分组命名',
  dbi_success_delete: '删除成功',
  dbi_success_opt: '操作成功！',
  dbi_group_delete_failed_again: '删除失败，请重试！',
  dbi_want_delete_this_group: '您想删除选中的分组吗？',
  dbi_games_group_will_move_to: '此分组的游戏将会转移至',
  dbi_followed_successfully: '收藏成功',
  dbi_followed_failed_again: '收藏失败，请重试！',
  dbi_added_failed_again: '添加失败，请重试！',
  dbi_successfully_added: '添加成功!',
  dbi_add_to: '添加至',
  dbi_move_to: '移动至',
  dbi_subscription_date: '订阅日期',
  dbi_top_metric: '指标',
  dbi_top_search_zone_here_and: '在此搜索品类。',

  dbi_segment_all: '全部',
  dbi_segment_full_game_key: `游戏拷贝`,
  dbi_segment_MTX_key: `微交易`,
  dbi_segment_DLC_all_other_key: `DLC：所有其他`,
  dbi_segment_DLC_expansion_key: `DLC：扩展`,
  dbi_segment_DLC_content_pre_purchase_pass_key: `DLC：季票`,
  dbi_segment_DLC_unlockable_content_pass_key: `DLC：战斗通行证`,
  dbi_segment_subscription_key: `订阅`,
  dbi_segment_in_game_currency_key: 'In-Game Currency',

  dbi_segment_full_game: `游戏实体包含游戏本体以及任何额外内容或独立扩展包的版本。`,
  dbi_segment_MTX: `一种需要游戏本体才可重复购买的商品。通常指游戏中的虚拟货币、卡包、战利品箱等。`,
  dbi_segment_DLC_all_other: `每个账户购买一次的内容，但未细分到上述类别中（例如，用现金购买的皮肤包）。对于较小的游戏，“DLC:解锁内容通行证”、“DLC:内容预购通行证”或“DLC:扩展版”可能尚未推出，因此所有DLC内容都将被归类为“DLC:所有其他”。`,
  dbi_segment_DLC_expansion: `用户每个帐户购买一次的内容，可提供对扩展内容的访问（例如，通过新区域、故事和功能扩展游戏玩法的内容）。`,
  dbi_segment_DLC_content_pre_purchase_pass: `这些是为进行购买的帐户预先购买未发布的DLC内容的交易。`,
  dbi_segment_DLC_unlockable_content_pass: `这些交易为购买的账户提供基于进度的可解锁内容。`,
  dbi_segment_subscription: `游戏内订阅服务。仅适用于部分游戏。`,

  dbi_delivery_time_dau: 'data.ai的日活用户数量和周活用户数量递送时间为次周周六。',
  dbi_delivery_time_revenue: 'data.ai的收入和下载数据递送时间为隔天。',
  dbi_delivery_time_common: 'data.ai的DAU和WAU数据递送时间为次周周六，data.ai的Revenue和Downloads数据递送时间为隔天。',

  dbi_genrefeedback_title: '品类反馈',
  dbi_genrefeedback_desc: '您可以编辑以调整品类。 当我们收到反馈后，我们将进行内部讨论然后调整页面的品类信息。',
  dbi_genrefeedback_main_genre_search_placeholder: '搜索任意主品类',
  dbi_genrefeedback_sub_genre_search_placeholder: '搜索任意副品类',
  dbi_genrefeedback_disabled_confirm_tips: '请选择一个主品类和两个副品类。',

  dbi_top_metrictype: '指标类型',
  dbi_top_sources: '数据源',
  dbi_top_granularity: '时间粒度',
  dbi_top_granularity_tips: '日/周/月粒度对应不同的指标',
  dbi_top_metric_intotal: '指标({number})',
  dbi_commpare_metric_metrics_set: '指标集',
  dbi_detail_game_not_launch_tips: '游戏还未上线。',
  dbi_detail_common_nodata_tips: '对不起，数据库内所有渠道都没有数据。',
  dbi_detail_downloadable_content_nodata_tips: '数据库中没有DLC信息。',
  dbi_detail_release_date_by_platform_nodata_tips: '发布日期未确定。',
  dbi_detail_description_nodata_tips: '数据库中没有这个游戏的描述。',
  dbi_detail_similar_games_nodata_tips: '我们正在整理类似的游戏。',
  dbi_detail_sensor_tower_tag: 'Sensor Tower标签',
  dbi_detail_appmagic_tag: 'App Magic标签',
  dbi_detail_art_style: '艺术风格',
  dbi_detail_camera_pov: '镜头视角',
  dbi_detail_product_model: '产品模型',
  dbi_detail_setting: '设定',
  dbi_detail_tags: '游戏标签',
  dbi_detail_theme: '主题',
  dbi_detail_monetization: '盈利模式',

  dbi_pcdevice_icon_tooltips: '除了Steam和Epic Games之外的其他PC device',
  dbi_detail_table_allcountries: '所有国家',
  dbi_detail_table_allgames: '所有游戏',
  dbi_detail_table_total: '总计',
  dbi_detail_revenue_allcountries_tip: '由于我们收集的是 48 个核心国家的数据，因此所有国家的收入可能略少。',
  dbi_detail_download_allcountries_tip: '由于我们收集的是 48 个核心国家的数据，因此所有国家的下载量可能略少。',
  dbi_top_kpiOverview_timeSpentPlaying: '游玩时长',
  dbi_top_kpiOverview_timeSpentPlaying_info: '活跃玩家的月平均游戏时长（总时长/月活）。用户活跃度指标目前按月更新。',
  dbi_top_kpiOverview_timeSpentPlaying_info_come: '月平均游玩时长（小时）数据来源于 DataBrain 内部。',
  dbi_top_kpiOverview_steamGamesOwned: 'Steam拥有的游戏',
  dbi_top_kpiOverview_steamGamesOwned_info: '根据评论语言得出的玩家国家分布。',
  dbi_top_kpiOverview_steamGamesOwned_info_come: '玩家市场分布数据来源于 VG insights',
  dbi_top_learn_more: '更多',
  dbi_top_single_metric: '指标',
  dbi_top_comment: '备注',
  dbi_top_public_data: '外部公开信息',
  dbi_top_public_data_desc: '该模块游戏数据来源于外部公开信息。',
  dbi_top_go_to_original_url: '跳转源链接',
  dbi_top_very_positive: '非常好评',
  dbi_top_positive: '好评',
  dbi_top_negative: '差评',
  dbi_top_show_more: '展开更多无更新指标',
  dbi_top_hide_more: '收起更多无更新指标',
  dbi_top_placeholder_metrics: '请选择指标',
  dbi_top_kpiOverview_players_by_country: '玩家市场分布',
  dbi_top_kpiOverview_avg_play_time: '平均游玩时长(小时)',
  // dbi_top_kpiOverview_avg_play_time_hrs: '平均游玩时长(小时)',
  dbi_top_kpiOverview_avg_play_time_hrs: '月平均游玩时长(小时)',
  dbi_top_kpiOverview_median_play_time: '中位数游玩时长(小时)',

  dbi_top_pc_console_filter_reset: '点击后会清除自定义的筛选项。',
  dbi_top_compare_modal_context: '您是否确定删除该游戏?',
  dbi_operation_successful_tips: '操作成功!',

  dbi_top_steam_tags: 'Steam品类标签',
  dbi_top_steam_tags_tip: 'Steam Tags来自Steam平台，玩家添加的游戏标签',
  dbi_top_steam_tags_placeholder: '选择任何Steam标签',
  dbi_top_steam_tags_search_placeholder: '搜索任何Steam标签',
  dbi_steam_tags_logic_label: '选择 And/Or 标签',
  dbi_steam_tags_logic_tip: '选择 "And" 时，游戏必须同时符合所有已选标签；选择 "Or" 时，只要游戏符合任意一个标签即会被选中。',

  dbi_top_game_mode: '游戏模式',
  dbi_top_game_mode_tip: '来自Steam平台游戏页面的标签',
  dbi_top_game_mode_placeholder: '选择任何游戏模式',
  dbi_top_game_mode_search_placeholder: '搜索任何游戏模式',
  dbi_top_publisher_class_placeholder: '选择任何发行商规模',
  dbi_top_publisher_class_search_placeholder: '搜索任何发行商规模',
  dbi_top_publisher_class_tip: '根据 {gamalyticDataSourceIcon} Gamalytics、{alineaDataSourceIcon} Alinea 与 {mscienceDataSourceIcon} MScience 的发行商累计收入估算进行分类，并取各数据源中的最高值判断发行商体量，以减少单一数据源对 GaaS 等收入口径覆盖不足带来的偏差。覆盖 PC 市场收入，每周更新。',

  dbi_top_game_engine: '游戏引擎',
  dbi_supported_platforms: '支持平台',
  dbi_top_game_engine_tip: '游戏开发框架。标签信息来自于IGDB平台。',
  dbi_top_game_engine_placeholder: '选择任何游戏引擎',
  dbi_top_game_engine_search_placeholder: '搜索任何游戏引擎',
  dbi_game_engine_logic_label: '选择 And/Or 游戏引擎',
  dbi_game_engine_logic_tip: '选择 "And" 时，游戏必须同时符合所有已选标签；选择 "Or" 时，只要游戏符合任意一个标签即会被选中。',

  dbi_top_steam_news_jump_tip: '前往原网站查看更多游戏活动',

  dbi_top_data_issue: '数据问题',

  dbi_top_show_all_true_data_text: '展示所有真数',
  dbi_top_calibration_metrics_switcher_text: '切换至校准指标',
  dbi_top_calibration_metrics_switcher_tips: '此游戏具有DataBrain校准后数据，点击可切换查看校准指标。',
  dbi_top_calibration_metrics_switcher_disabled_tips: '已为您切换至校准指标。',
  dbi_sensortower_tags: 'Sensor Tower标签',

  dbi_top_appmagic_genre: 'App Magic品类',

  dbi_show_rising_games: '展示异动游戏',

  // 异动指标
  dbi_surge_metric_placeholder: '异动指标',
  dbi_surge_metric_dau: '活跃异动',
  dbi_surge_metric_wau: '活跃异动',
  dbi_surge_metric_mau: '活跃异动',
  dbi_surge_metric_revenue: '收入异动',
  dbi_surge_metric_download: '下载异动',
  dbi_surge_metric_units: '销量异动',
  dbi_surge_metric_pcu: 'PCU异动',
  dbi_surge_metric_tooltip_mobile:
    '展示当前筛选逻辑下的指标Top 500游戏，按变化率降序排列。选择异动指标后，对下方表格进行重排序等操作将仅涉及当前 Top500 游戏。取消勾选可恢复默认榜单',
  dbi_surge_metric_tooltip_combine:
    '展示当前筛选逻辑下的指标Top 500游戏，按变化率降序排列。选择异动指标后，对下方表格进行重排序等操作将仅涉及当前 Top500 游戏。取消勾选可恢复默认榜单。\n收入取MScience收入指标，销量取MScience销量指标，PCU取自Steam官方PCU数据，DAU/MAU取Other Vendor DAU/MAU指标。',

  // Steam Hourly CCU
  dbi_top_kpiOverview_steam_hourly_ccu: 'Steam 小时级 CCU',
  dbi_top_kpiOverview_steam_hourly_ccu_info:
    'Steam 当前实时在线玩家数，数据按小时级频次采集，来源于Steam官方API，数据源爬取从2026年2月开始。',
  dbi_top_kpiOverview_steam_hourly_ccu_today: '当日',
  dbi_top_kpiOverview_steam_hourly_ccu_yesterday: '昨日同期',
  dbi_top_kpiOverview_steam_hourly_ccu_same_day_last_week: '上周同期',
  dbi_top_kpiOverview_steam_hourly_ccu_contrast_day: '对比日',
  dbi_top_kpiOverview_steam_hourly_ccu_dod: '日环比',
  dbi_top_kpiOverview_steam_hourly_ccu_sdlw: '上周同期',
  // Top Charts / PC & Console Games / Alinea Analytics Calibration
  dbi_alinea_analytics_calibration: 'Alinea Analytics 真实数据',
  // Top Charts / Event Details
  dbi_top_event_start_date: '开始日期',
  dbi_top_event_end_date: '结束日期',
};
// 此文档 新增请改dbi_top_为前缀
